import { render, staticRenderFns } from "./votoPiatto.vue?vue&type=template&id=6e397040&"
import script from "./votoPiatto.vue?vue&type=script&lang=js&"
export * from "./votoPiatto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports